<template>
  <div>
    <b-card body-bg-variant="light"
            class="ma-5"
            header="Affiliations"
            header-bg-variant="dark"
            header-text-variant="light">
      <b-button :pressed.sync="showFilter"
                class="mb-2">
        FILTER
      </b-button>
      <div class="right div--button">
        Rows: {{ users.length }}
      </div>
      <b-table :current-page="currentPage"
               :fields="fields"
               :items="users"
               :per-page="perPage"
               class="table-responsive"
               head-variant="light"
               hover
               responsive
               striped>

        <template v-slot:top-row="{fields}">
          <proposal-filter :id="id"
                           v-model="users"
                           :fields="fields"
                           :not-include-key="['actions', 'ordinalNumber']"/>
        </template>

        <template v-slot:cell(ordinalNumber)="row">
          <base-column-ordinal-number v-bind="{index: row.index, perPage, currentPage}"/>
        </template>

        <template v-slot:cell(actions)="row">
          <b-btn v-b-modal.affiliation_modal
                 variant="outline-info"
                 @click="open_affiliation(row)">MANAGE
          </b-btn>
        </template>

      </b-table>
      <b-table-footer v-model="loading"
                      :current-page="currentPage"
                      :data-length="users.length"
                      :per-page="perPage"
                      @change-page="changePage">
        <template v-slot>
          <base-per-page-input v-model="perPage"/>
        </template>
      </b-table-footer>
    </b-card>
    <b-modal id="affiliation_modal"
             lazy
             @ok="save_data">
      <affiliation-form v-model="affiliation"
                        :validator="validator"
                        is-operator
                        @is-invalid="isInvalid">
        <template v-slot:header>
          <b-form-select v-if="affiliation.states"
                         v-model="affiliation.states.name"
                         :options="affiliation_states"
                         class="mb-3"/>
        </template>
      </affiliation-form>
    </b-modal>
  </div>
</template>

<script>
  import { affiliationValidatorIsOperator } from '@/assets/validators/affiliationValidator';
  import AffiliationForm from '@/components/AffiliationForm';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';
  import { ordinalNumber } from '@/helpers/commonTableColumns';

  export default {
    components: {
      AffiliationForm,
      BaseColumnOrdinalNumber,
      BasePerPageInput,
      BTableFooter,
      ProposalFilter,
    },
    data() {
      return {
        // necessary for proposal and calls filter feature
        id: 1,
        // use only for visual effect and trigger event for filter component
        showFilter: false,

        loading: false,
        validator: affiliationValidatorIsOperator,
        currentPage: 1,
        perPage: 20,
        users: [],
        user_id: undefined,
        aff_index: 0,
        affiliation_states: [],
        affiliation: {},
        temp_affiliation: undefined,
        isAffiliationInvalid: false,
        fields: [
          ordinalNumber,
          {
            key: 'title',
            thStyle: { width: '5%' },
          },
          'first_name',
          'last_name',
          {
            key: 'email',
            label: 'Main email',
          },
          {
            key: 'affiliations.email',
            label: 'Affiliation email',
          },
          {
            key: 'affiliations.organization.name',
            label: 'Organization name',
            formatter: (value) => (value || 'N/A'),
          },
          {
            key: 'affiliations.organization.city',
            label: 'Organization city',
            formatter: (value) => (value || 'N/A'),
          },
          {
            key: 'affiliations.organization.country',
            label: 'Organization country',
            formatter: (value) => (value || 'N/A'),
          },
          {
            key: 'affiliations.states.name',
            label: 'State',
            formatter: (value) => (value ? this.$options.filters.pretty(value) : 'N/A'),
          },
          {
            key: 'affiliations.states.date',
            label: 'Last modified',
            formatter: (value) => (value || 'N/A'),
          },
          { key: 'actions' },
        ],
      };
    },
    methods: {
      load_data() {
        this.loading = true;
        this.axios.all([
          this.axios.get('/users/affiliations'),
          this.axios.get('affiliations/states'),
        ])
          .then(this.axios.spread((users, states) => {
            this.users = users.data;
            this.$emit('setup-proposal', this.users);
            this.affiliation_states = states.data;
          }))
          .finally(() => {
            this.loading = false;
          });
      },
      changePage(val) {
        this.currentPage = val;
      },
      isInvalid(state) {
        this.isAffiliationInvalid = state;
      },
      open_affiliation(row) {
        this.user_id = this.getId(row.item);
        this.aff_index = row.item.arrayIndex;
        this.temp_affiliation = row;
        this.affiliation = JSON.parse(JSON.stringify(row.item.affiliations));
      },
      save_data() {
        if (!this.isAffiliationInvalid) {
          this.axios.patch(`/affiliations/${this.user_id}/${this.aff_index}`, this.affiliation)
            .then(() => {
              this.$set(this.temp_affiliation.item, 'affiliations', this.affiliation);
              this.$notify({ type: 'success', title: 'Affiliation saved successfully!' });
            })
            .catch(() => {
              this.$notify({ type: 'error', title: 'Affiliation cannot be saved!' });
              this.load_data();
            });
        } else {
          this.$notify({ type: 'error', title: 'A reason is required for a rejected affiliation!' });
        }
      },
    },
    mounted() {
      this.load_data();
    },
    watch: {
      showFilter() {
        this.$emit('toggle-show');
      },
    },
  };
</script>

<style scoped>
</style>
